import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "./assets/Burakyol-logo.jpeg";

const About = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [scrollY, setScrollY] = useState(0);

    useEffect(() => {
        const handleScroll = () => setScrollY(window.scrollY);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className="min-h-screen bg-white">
            {/* Logo - Navbarın Dışında Sol Tarafta (Large Screens) */}
            <div className="hidden xl:block absolute left-[15vw] 2xl:left-[22vw] 3xl:left-[28rem] top-[60px] -translate-y-1/2 z-40 pointer-events-auto w-[80px] h-[80px] 2xl:w-[90px] 2xl:h-[90px] 3xl:w-[100px] 3xl:h-[100px] rounded-full flex items-center justify-center shrink-0 overflow-hidden shadow-xl">
                <img
                    src={logo}
                    alt="Logo"
                    className="w-full h-full object-cover"
                />
            </div>
        
            {/* ========== Navbar ========== */}
            <header className="fixed top-[12px] md:top-[24px] left-0 right-0 z-50 flex items-center justify-center px-4 md:px-sm w-full pointer-events-none">
                <div className="pointer-events-auto w-full max-w-[700px] h-[60px] md:h-[72px] flex items-center justify-between bg-[#01346b] backdrop-blur-xl rounded-full px-4 md:px-xs py-xs shadow-xl border border-white/10">
                    <div className="flex items-center gap-4 pl-2 md:pl-xs">
                        <div className="md:hidden w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                            <img src={logo} alt="Logo" className="w-full h-full object-cover" />
                        </div>
                        
                        <nav className="hidden md:flex items-center gap-6 pl-4">
                            <Link to="/hakkimizda" className="font-label text-label text-page-bg hover:text-page-bg transition-colors duration-300">Hakkımızda</Link>
                            <Link to="/projeler" className="font-label text-label text-page-bg/80 hover:text-page-bg transition-colors duration-300">Projeler</Link>
                            <Link to="/hizmetler" className="font-label text-label text-page-bg/80 hover:text-page-bg transition-colors duration-300">Hizmetler</Link>
                            <Link to="/iletisim" className="font-label text-label text-page-bg/80 hover:text-page-bg transition-colors duration-300">İletişim</Link>
                        </nav>
                        
                        <button 
                            className="md:hidden text-white p-14"
                            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                            aria-label="Toggle menu"
                        >
                            {mobileMenuOpen ? (
                                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            ) : (
                                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                </svg>
                            )}
                        </button>
                    </div>
                    <Link to="/" className="bg-page-bg text-black font-label text-sm md:text-label h-full px-4 md:px-8 rounded-full hover:bg-white transition-colors duration-300 scale-95 hover:scale-100 shrink-0 flex items-center shadow-sm">
                        Anasayfa
                    </Link>
                </div>

                <div 
                    className={`md:hidden absolute top-[72px] left-4 right-4 bg-[#01346b] backdrop-blur-xl rounded-3xl shadow-2xl border border-white/10 overflow-hidden pointer-events-auto transition-all duration-500 ease-out ${
                        mobileMenuOpen 
                            ? 'opacity-100 translate-y-0 max-h-96' 
                            : 'opacity-0 -translate-y-4 max-h-0 pointer-events-none'
                    }`}
                >
                    <nav className="flex flex-col p-4">
                        <Link to="/hakkimizda" className="text-white py-4 px-4 hover:bg-white/10 rounded-xl transition-all duration-300 font-medium transform hover:translate-x-2" onClick={() => setMobileMenuOpen(false)}>Hakkımızda</Link>
                        <Link to="/projeler" className="text-white py-4 px-4 hover:bg-white/10 rounded-xl transition-all duration-300 font-medium transform hover:translate-x-2" onClick={() => setMobileMenuOpen(false)}>Projeler</Link>
                        <Link to="/hizmetler" className="text-white py-4 px-4 hover:bg-white/10 rounded-xl transition-all duration-300 font-medium transform hover:translate-x-2" onClick={() => setMobileMenuOpen(false)}>Hizmetler</Link>
                        <Link to="/iletisim" className="text-white py-4 px-4 hover:bg-white/10 rounded-xl transition-all duration-300 font-medium transform hover:translate-x-2" onClick={() => setMobileMenuOpen(false)}>İletişim</Link>
                    </nav>
                </div>
            </header>

            {/* Hero Section - Modern Minimal */}
            <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-[#01346b] via-[#01346b] to-[#024a8f]">
                {/* Animated Background Pattern */}
                <div className="absolute inset-0 opacity-10">
                    <div className="absolute top-20 left-20 w-72 h-72 bg-white rounded-full blur-3xl animate-pulse"></div>
                    <div className="absolute bottom-20 right-20 w-96 h-96 bg-white rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
                    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-white/20 rounded-full blur-3xl"></div>
                </div>

                {/* Grid Pattern */}
                <div className="absolute inset-0 opacity-5" style={{
                    backgroundImage: 'linear-gradient(white 1px, transparent 1px), linear-gradient(90deg, white 1px, transparent 1px)',
                    backgroundSize: '50px 50px'
                }}></div>

                <div className="max-w-[1200px] mx-auto px-4 md:px-8 relative z-10 text-center py-32">
                    <div className="inline-flex items-center gap-2 px-6 py-3 bg-white/20 backdrop-blur-md rounded-full mb-8 animate-fade-in-down">
                        <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
                        <span className="text-white text-sm font-semibold tracking-wider">2016'DAN BUGÜNE</span>
                    </div>
                    
                    <h1 className="font-display text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight animate-fade-in" style={{ animationDelay: '0.2s' }}>
                        Geleceği İnşa Eden<br />
                        <span className="bg-gradient-to-r from-white to-white/80 bg-clip-text text-transparent">Güvenilir Ortak</span>
                    </h1>
                    
                    <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto leading-relaxed mb-12 animate-fade-in" style={{ animationDelay: '0.4s' }}>
                        Modern teknolojiler ve yenilikçi çözümlerle Türkiye'nin altyapı ve üstyapı projelerine değer katıyor, sürdürülebilir yaşam alanları inşa ediyoruz.
                    </p>

                    {/* Scroll Indicator */}
                    <div className="animate-bounce mt-16">
                        <svg className="w-6 h-6 text-white/70 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                        </svg>
                    </div>
                </div>
            </section>

            {/* Biz Kimiz - Modern Card Layout */}
            <section className="py-20 md:py-32 bg-white relative overflow-hidden">
                {/* Decorative Elements */}
                <div className="absolute top-0 right-0 w-96 h-96 bg-[#01346b]/5 rounded-full blur-3xl"></div>
                <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#01346b]/5 rounded-full blur-3xl"></div>

                <div className="max-w-[1200px] mx-auto px-4 md:px-8 relative z-10">
                    <div className="text-center mb-16">
                        <span className="inline-block px-6 py-2 bg-[#01346b]/10 text-[#01346b] rounded-full text-sm font-bold mb-4 tracking-wider">
                            HAKKIMIZDA
                        </span>
                        <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-[#01346b] mb-6">
                            Biz Kimiz?
                        </h2>
                    </div>

                    <div className="grid md:grid-cols-2 gap-8 items-center">
                        {/* Left - Content */}
                        <div className="space-y-6">
                            <div className="bg-gradient-to-br from-[#01346b] to-[#024a8f] rounded-3xl p-8 md:p-10 text-white relative overflow-hidden group">
                                <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full blur-2xl group-hover:scale-150 transition-transform duration-700"></div>
                                <div className="relative">
                                    <div className="flex items-center gap-3 mb-4">
                                        <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
                                            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                            </svg>
                                        </div>
                                        <span className="text-2xl font-bold">2016</span>
                                    </div>
                                    <p className="text-white/90 text-lg leading-relaxed">
                                        2016 yılından bu yana, <span className="font-bold text-white">Burakyol Mühendislik</span> olarak Türkiye'nin önde gelen inşaat şirketlerinden biri olarak hizmet vermekteyiz. Sürdürülebilir ve yenilikçi projelerimizle, çevre dostu yaklaşımımız ve modern teknolojilerimizle, geleceğin yaşam alanlarını inşa ediyoruz.
                                    </p>
                                </div>
                            </div>

                            <div className="bg-white border-2 border-gray-100 rounded-3xl p-8 md:p-10 hover:border-[#01346b]/30 hover:shadow-2xl transition-all duration-300 group">
                                <div className="flex items-center gap-3 mb-4">
                                    <div className="w-12 h-12 bg-[#01346b]/10 rounded-xl flex items-center justify-center group-hover:bg-[#01346b] transition-colors duration-300">
                                        <svg className="w-6 h-6 text-[#01346b] group-hover:text-white transition-colors duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                                        </svg>
                                    </div>
                                    <span className="text-2xl font-bold text-[#01346b]">Mükemmellik</span>
                                </div>
                                <p className="text-gray-700 text-lg leading-relaxed">
                                    Uzman kadromuz, yüksek kalite standartlarımız ve müşteri memnuniyeti odaklı yaklaşımımızla, her projemizde mükemmelliği hedefliyoruz. Konut projelerinden altyapı çalışmalarına, ticari yapılardan endüstriyel tesislere kadar geniş bir yelpazede hizmet sunuyoruz.
                                </p>
                            </div>
                        </div>

                        {/* Right - Stats Grid */}
                        <div className="grid grid-cols-2 gap-6">
                            {[
                                { 
                                    value: "50+", 
                                    label: "Tamamlanan Proje",
                                    icon: <path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />,
                                    bgColor: "bg-blue-50",
                                    iconColor: "text-blue-600"
                                },
                                { 
                                    value: "100+", 
                                    label: "Uzman Kadro",
                                    icon: <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />,
                                    bgColor: "bg-emerald-50",
                                    iconColor: "text-emerald-600"
                                },
                                { 
                                    value: "10+", 
                                    label: "Yıllık Tecrübe",
                                    icon: <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />,
                                    bgColor: "bg-amber-50",
                                    iconColor: "text-amber-600"
                                },
                                { 
                                    value: "%98", 
                                    label: "Müşteri Memnuniyeti",
                                    icon: <path strokeLinecap="round" strokeLinejoin="round" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />,
                                    bgColor: "bg-purple-50",
                                    iconColor: "text-purple-600"
                                }
                            ].map((stat, idx) => (
                                <div key={stat.label} className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-6 md:p-8 border border-gray-200 hover:border-[#01346b]/30 hover:shadow-xl transition-all duration-300 group">
                                    <div className={`w-14 h-14 ${stat.bgColor} rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                                        <svg className={`w-7 h-7 ${stat.iconColor}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                            {stat.icon}
                                        </svg>
                                    </div>
                                    <div className="font-display text-4xl font-bold text-[#01346b] mb-2">{stat.value}</div>
                                    <p className="text-gray-600 text-sm font-medium">{stat.label}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            {/* Vision & Mission - Side by Side Cards */}
            <section className="py-20 md:py-32 bg-[#f8f9fa]">
                <div className="max-w-[1200px] mx-auto px-4 md:px-8">
                    <div className="grid md:grid-cols-2 gap-8">
                        {/* Vision */}
                        <div className="group relative">
                            <div className="absolute inset-0 bg-gradient-to-br from-[#01346b] to-[#024a8f] rounded-3xl transform group-hover:scale-105 transition-transform duration-500 opacity-90 group-hover:opacity-100"></div>
                            <div className="relative bg-gradient-to-br from-[#01346b] to-[#024a8f] rounded-3xl p-10 md:p-12 overflow-hidden">
                                <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl"></div>
                                <div className="relative">
                                    <div className="w-20 h-20 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                                        <svg className="w-10 h-10 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                        </svg>
                                    </div>
                                    <h3 className="font-display text-3xl md:text-4xl font-bold text-white mb-4">
                                        Vizyonumuz
                                    </h3>
                                    <p className="text-white/90 text-lg leading-relaxed">
                                        Türkiye'nin en güvenilir ve yenilikçi inşaat firması olarak, uluslararası standartlarda projeler üreterek sektörde lider konumda olmak ve sürdürülebilir şehircilik anlayışına öncülük etmek.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Mission */}
                        <div className="group relative">
                            <div className="absolute inset-0 bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-3xl transform group-hover:scale-105 transition-transform duration-500 opacity-90 group-hover:opacity-100"></div>
                            <div className="relative bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-3xl p-10 md:p-12 overflow-hidden">
                                <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl"></div>
                                <div className="relative">
                                    <div className="w-20 h-20 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                                        <svg className="w-10 h-10 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                                        </svg>
                                    </div>
                                    <h3 className="font-display text-3xl md:text-4xl font-bold text-white mb-4">
                                        Misyonumuz
                                    </h3>
                                    <p className="text-white/90 text-lg leading-relaxed">
                                        Kalite, güvenlik ve sürdürülebilirlik ilkeleriyle hareket ederek, her projede müşteri memnuniyetini ön planda tutmak ve topluma değer katan yapılar inşa etmek.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Core Values - Icon Grid */}
            <section className="py-20 md:py-32 bg-white">
                <div className="max-w-[1200px] mx-auto px-4 md:px-8">
                    <div className="text-center mb-16">
                        <span className="inline-block px-6 py-2 bg-[#01346b]/10 text-[#01346b] rounded-full text-sm font-bold mb-4 tracking-wider">
                            DEĞERLERIMIZ
                        </span>
                        <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-[#01346b] mb-4">
                            Temel Değerlerimiz
                        </h2>
                        <p className="text-gray-600 text-xl max-w-2xl mx-auto">
                            Her projede titizlikle uyguladığımız değerler, başarımızın temelidir
                        </p>
                    </div>

                    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                        {[
                            {
                                title: "Güvenlik",
                                desc: "İş sağlığı ve güvenliği önceliğimiz. Sıfır kaza prensibiyle çalışıyoruz.",
                                icon: <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />,
                                gradient: "from-blue-500 to-blue-600"
                            },
                            {
                                title: "Kalite",
                                desc: "ISO standartlarında malzeme ve işçilik, uzun ömürlü yapılar.",
                                icon: <path strokeLinecap="round" strokeLinejoin="round" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />,
                                gradient: "from-amber-500 to-amber-600"
                            },
                            {
                                title: "İnovasyon",
                                desc: "Modern teknolojiler ve yenilikçi mühendislik çözümleri.",
                                icon: <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />,
                                gradient: "from-emerald-500 to-emerald-600"
                            },
                            {
                                title: "Güvenilirlik",
                                desc: "Zamanında teslimat ve sürekli destek ile güven inşa ediyoruz.",
                                icon: <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />,
                                gradient: "from-purple-500 to-purple-600"
                            }
                        ].map((value, idx) => (
                            <div key={value.title} className="group relative">
                                <div className="absolute inset-0 bg-gradient-to-br from-gray-50 to-white rounded-2xl transform group-hover:scale-105 transition-transform duration-300"></div>
                                <div className="relative bg-white rounded-2xl p-8 border-2 border-gray-100 group-hover:border-transparent group-hover:shadow-2xl transition-all duration-300">
                                    <div className={`w-16 h-16 bg-gradient-to-br ${value.gradient} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300 shadow-lg`}>
                                        <svg className="w-8 h-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                            {value.icon}
                                        </svg>
                                    </div>
                                    <h3 className="font-display text-xl font-bold text-gray-900 mb-3">
                                        {value.title}
                                    </h3>
                                    <p className="text-gray-600 leading-relaxed">
                                        {value.desc}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Timeline - Animated with Polyline */}
            <section className="py-20 md:py-32 bg-[#f8f9fa] relative overflow-hidden">
                <div className="max-w-[1200px] mx-auto px-4 md:px-8">
                    <div className="text-center mb-16">
                        <span className="inline-block px-6 py-2 bg-[#01346b]/10 text-[#01346b] rounded-full text-sm font-bold mb-4 tracking-wider">
                            TARİHÇEMİZ
                        </span>
                        <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-[#01346b] mb-4">
                            Yolculuğumuz
                        </h2>
                        <p className="text-gray-600 text-xl max-w-2xl mx-auto">
                            2016'dan bugüne kadar attığımız önemli adımlar
                        </p>
                    </div>

                    <div className="relative pl-8 md:pl-0">
                        {/* Animated Line - Desktop (Center) */}
                        <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-1 -translate-x-1/2 bg-gradient-to-b from-[#01346b] to-[#01346b]/30"></div>

                        {/* Animated Line - Mobile (Left Side) */}
                        <div className="md:hidden absolute left-3 top-0 bottom-0 w-0.5 bg-gradient-to-b from-[#01346b] to-[#01346b]/30"></div>

                        <div className="space-y-12 md:space-y-20 relative">
                            {[
                                {
                                    year: "2016",
                                    title: "Kuruluş",
                                    description: "Burakyol İnşaat, inşaat sektöründe fark yaratmak amacıyla kuruldu. İlk projemiz olan altyapı çalışmalarıyla sektöre adım attık.",
                                    icon: <path strokeLinecap="round" strokeLinejoin="round" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                                },
                                {
                                    year: "2018",
                                    title: "Büyüme ve Genişleme",
                                    description: "Başarılı projelerimizle portföyümüzü genişlettik. Kentsel dönüşüm ve altyapı projelerinde uzmanlaşarak kadromuzu güçlendirdik.",
                                    icon: <path strokeLinecap="round" strokeLinejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                                },
                                {
                                    year: "2020",
                                    title: "Teknoloji Entegrasyonu",
                                    description: "Kalite yönetim sistemimizi modern teknolojilerle güçlendirdik. Sürdürülebilirlik ilkelerini benimsedik ve dijital dönüşümümüzü tamamladık.",
                                    icon: <path strokeLinecap="round" strokeLinejoin="round" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                },
                                {
                                    year: "2023",
                                    title: "Büyük Ölçekli Projeler",
                                    description: "50+ büyük ölçekli proje tamamladık. TOKİ, İller Bankası ve KGM gibi kurumlarla stratejik iş ortaklıkları kurduk.",
                                    icon: <path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                },
                                {
                                    year: "2026",
                                    title: "Gelecek Vizyonu",
                                    description: "Akıllı şehir projeleri ve çevre dostu inşaat teknolojilerine odaklanarak, geleceğin yaşam alanlarını tasarlıyoruz.",
                                    icon: <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
                                }
                            ].map((item, index) => (
                                <div
                                    key={item.year}
                                    className={`flex items-center gap-8 relative ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}
                                >
                                    {/* Mobile Dot (Left Side) */}
                                    <div className="md:hidden absolute -left-5 w-5 h-5 bg-[#01346b] rounded-full border-4 border-white shadow-xl z-10">
                                        <div className="absolute inset-0 bg-[#01346b] rounded-full animate-ping opacity-75"></div>
                                    </div>

                                    {/* Content Card */}
                                    <div className={`flex-1 ${index % 2 === 0 ? 'md:text-right' : 'md:text-left'} relative z-10`}>
                                        <div className="inline-block group">
                                            <div className="bg-white rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-gray-100 hover:border-[#01346b]/30">
                                                <div className="flex items-center gap-4 mb-4" style={{ flexDirection: index % 2 === 0 ? 'row-reverse' : 'row' }}>
                                                    <div className="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-[#01346b] to-[#024a8f] rounded-xl flex items-center justify-center text-white font-bold text-lg shadow-lg group-hover:scale-110 transition-transform duration-300">
                                                        <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                                            {item.icon}
                                                        </svg>
                                                    </div>
                                                    <div>
                                                        <div className="text-3xl md:text-4xl font-bold text-[#01346b]">{item.year}</div>
                                                    </div>
                                                </div>
                                                <h3 className="font-display text-2xl font-bold text-gray-900 mb-3">
                                                    {item.title}
                                                </h3>
                                                <p className="text-gray-600 leading-relaxed">
                                                    {item.description}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Center Dot - Desktop */}
                                    <div className="hidden md:flex flex-shrink-0 w-6 h-6 bg-[#01346b] rounded-full border-4 border-white shadow-xl relative z-10">
                                        <div className="absolute inset-0 bg-[#01346b] rounded-full animate-ping opacity-75"></div>
                                    </div>

                                    {/* Spacer */}
                                    <div className="hidden md:block flex-1 relative z-10"></div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="py-20 md:py-32 bg-gradient-to-br from-[#01346b] via-[#01346b] to-[#024a8f] relative overflow-hidden">
                <div className="absolute inset-0 opacity-10">
                    <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
                    <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
                </div>

                <div className="max-w-[1200px] mx-auto px-4 md:px-8 text-center relative z-10">
                    <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
                        Hayalinizdeki Projeyi<br />Birlikte İnşa Edelim
                    </h2>
                    <p className="text-xl md:text-2xl text-white/90 max-w-2xl mx-auto mb-10">
                        Uzman ekibimiz, projenizi en iyi şekilde hayata geçirmek için hazır
                    </p>
                    <button className="group bg-white text-[#01346b] px-10 py-5 rounded-2xl font-bold text-lg hover:bg-gray-100 transition-all duration-300 shadow-2xl hover:shadow-3xl hover:scale-105 inline-flex items-center gap-3">
                        <span>Bize Ulaşın</span>
                        <svg className="w-6 h-6 group-hover:translate-x-1 transition-transform duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                        </svg>
                    </button>
                </div>
            </section>

            <style jsx>{`
                @keyframes fade-in-down {
                    from {
                        opacity: 0;
                        transform: translateY(-20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                
                @keyframes fade-in {
                    from {
                        opacity: 0;
                    }
                    to {
                        opacity: 1;
                    }
                }

                .animate-fade-in-down {
                    animation: fade-in-down 0.8s ease-out;
                }

                .animate-fade-in {
                    animation: fade-in 1s ease-out;
                }
            `}</style>
        </div>
    );
};

export default About;
